<template>
  <div class="video_box" v-if="url">
    <div class="container">
      <div class="player">
        <video-player
          class="video-player vjs-custom-skin video-swiper"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
          @play="onPlayerPlay($event)"
          @pause="onPlayerPause($event)"
        ></video-player>
      </div>
    </div>
  </div>
</template>
 
<script>
import { videoPlayer } from "vue-video-player";
import { mapMutations } from "vuex";
export default {
  
  props:{
    url: {
      type: String,
      default:""
    },
    ind:{
      type:Number,
      default:99
    },
    time:{
      type:Number,
    },
    cover:{
      type:String,
    }
  },
  data() {
    return {
      videoUrl:
        "http://exshow.oss-cn-shanghai.aliyuncs.com/exshow/imgs/201902/f87d763f83af49d69d90cd0561fc02f2.jpg",
      playerOptions: {
        autoplay: false,
        muted: false,
        loop: false,
        preload: "auto",
        language: "zh-CN",
        aspectRatio: "16:9",
        fluid: true,
        sources: [
          {
            type: "video/mp4",
            src: this.url
          }
        ],
        poster: this.videoUrl, //你的封面地址
        width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      },
      state: "",
      paused: "",
      running: ""
    };
  },
  created() {
    this.ind
    if (this.url) {
      if(this.cover){
        this.videoUrl = this.cover;
      } else if(this.time){
        this.videoUrl = `${this.url}?x-oss-process=video/snapshot,t_${this.time},f_jpg,w_590,h_332,m_fast`;
      }
      this.playerOptions = {
        autoplay: false,
        muted: false,
        loop: false,
        preload: "auto",
        language: "zh-CN",
        aspectRatio: "16:9",
        fluid: true,
        sources: [
          {
            type: "video/mp4",
            src: this.url
          }
        ],
        poster: this.videoUrl, //你的封面地址
        width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      };
      const that = this;
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    }
  },
  components: {
    videoPlayer
  },
  methods: {
    // ...mapMutations({
    //   setVideoOpen: "setVideoOpen"
    // }),
    onPlayerPlay(player) {
      this.$emit('onPlayerPlay');
    },
    onPlayerPause(player) {
      this.$emit('onPlayerPause',this.ind);
    },
    //轮播改变
    swiperChange(){
      this.$refs['videoPlayer'].player.pause();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #f5f5f5;
  min-height: 100%;
}
.video_box,
.container,
.player,
.video-player {
  height: 100%;
}
.vjs-custom-skin > .video-js .vjs-control-bar{
  font-size: 0.24rem;
}
</style> 